module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0138.jpg?v=333e651a";